module.exports = __webpack_public_path__ + "img/gohrnew.d21e97fa.png";